import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import App from './App';

console.log('React 18 rendering with createRoot');

// Get the root element
const rootElement = document.getElementById('root');

// Check if the root element exists
if (rootElement) {
  // Create a root
  const root = createRoot(rootElement);
  
  // Render your app to the root
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error('Root element not found - make sure you have a div with id="root" in your index.html');
}